import React, { useState } from "react"
import { ChevronDown, Bus } from "lucide-react"
import { useSelector } from "react-redux"
import { selectAviaSearchCurrency } from "../../../../../app/reducers/book/aviaSearchSlice"
import Button from "../ui/Button"
import { CURRENCIES } from "../../../../../variables/common"

const transferOptions = [
  "Без трансфера",
  "С трансфером из аэропорта",
  "С трансфером в аэропорт",
  "С трансфером туда и обратно",
]
const FlightDetails = () => {
  const currency = useSelector(selectAviaSearchCurrency)
  const currencySymbol = CURRENCIES.find((item) => item.code === currency).symbol

  const [transferOption, setTransferOption] = useState("Без трансфера")
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="px-1 py-3 w-full max-w-[244px]">
      <div className="mb-2">
        <h2 className="text-sm text-gray-blue font-medium flex items-center gap-2">
          <span className="w-2 h-2 bg-gray-blue rounded-full"></span>
          Детали рейса
        </h2>
      </div>

      <div className="mb-6 relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full min-w-full flex items-center gap-3 p-1 text-left text-dark-gray bg-light-gray/20 hover:bg-light-gray/40 rounded-md transition-colors text-[13px]"
        >
          <Bus className="w-4 h-4 text-light-gray shrink-0" />
          <span className="flex-1 truncate min-w-0">{transferOption}</span>
          <ChevronDown
            className={`w-4 h-4 shrink-0 text-light-gray transition-transform ${isOpen ? "rotate-180" : ""}`}
          />
        </button>

        {isOpen && (
          <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-md z-10 h-28 overflow-y-auto">
            {transferOptions.map((option) => (
              <button
                key={option}
                onClick={() => {
                  setTransferOption(option)
                  setIsOpen(false)
                }}
                className="w-full text-[13px] px-2 py-1 text-left hover:bg-blue-50 transition-colors first:rounded-t-lg last:rounded-b-lg"
              >
                {option}
              </button>
            ))}
          </div>
        )}
      </div>

      <div>
        <div className="text-center mb-6">
          <div className="text-4xl font-semibold text-dark-gray mb-2">683{currencySymbol}</div>
          <div className="text-[18px] text-dark-red/50">для 2 пассажиров</div>
        </div>

        <div className="w-full flex items-center justify-center">
          <Button className="w-[80%]" color="darkGreen" size="md">
            Бронировать
          </Button>
        </div>
      </div>
    </div>
  )
}

export default FlightDetails
